import { detailedDiff } from 'deep-object-diff'

export const cp = (value: any) => JSON.parse(JSON.stringify(value))

export const formatCurrency = (value: number) => {
	if (!Number.isFinite(value) || value <= 0) return '€0'
	return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 }).format(
		value,
	)
}

export const diff = (obj1 = {}, obj2 = {}) => {
	const difference: any = detailedDiff(obj1, obj2)
	const diffs: any =
		Object.keys(difference.updated).length +
		Object.keys(difference.deleted).length +
		Object.keys(difference.added).length
	return { ...difference, isChanged: diffs > 0 }
}

export function imageFromFile(e: any): Promise<string | undefined> {
	return new Promise((resolve, reject) => {
		const rawFile: File = e.target.files?.[0]
		if (!rawFile || !rawFile.type.match(/image.*/)) {
			resolve(undefined)
			return
		}

		const reader = new FileReader()
		reader.onerror = (err) => reject(err)
		reader.onload = (evt: ProgressEvent<FileReader>) => {
			const img = new Image()
			img.onerror = (err) => reject(err)
			img.onload = () => {
				const { width, height } = img
				const ratio = width / height
				const okRatio = 320 / 240

				const canvas = document.createElement('canvas')
				canvas.width = 320
				canvas.height = 240
				const ctx = canvas.getContext('2d')!
				let h = 240,
					w1 = 240,
					wside = 0,
					ttop = 0

				if (ratio <= okRatio) {
					w1 = 320
					h = (320 * height) / width
					ttop = (240 - h) / 2
				} else {
					h = 240
					w1 = 240 * ratio
					wside = (320 - w1) / 2
				}

				ctx.drawImage(img, wside, ttop, w1, h)
				const dataUrl = canvas.toDataURL('image/jpeg')
				resolve(dataUrl)
			}
			img.src = evt.target?.result as string
		}
		reader.readAsDataURL(rawFile)
	})
}
type anyType = Record<string, unknown> | Array<unknown> | string | number | boolean | null | undefined

export const isDeepSame = (obj1: anyType, obj2: anyType) => {
	obj1 = cp(obj1)
	obj2 = cp(obj2)
	if (obj1 === obj2) return true
	if (typeof obj1 !== 'object' || typeof obj2 !== 'object') return false
	if (obj1 === null || obj2 === null) return false

	const keys1 = Object.keys(obj1)
	const keys2 = Object.keys(obj2)

	if (keys1.length !== keys2.length) return false

	for (const key of keys1) {
		if (!keys2.includes(key)) return false
		if (!isDeepSame(obj1[key], obj2[key])) return false
	}

	return true
}

export const dotify = (obj: any) => {
	const res: any = {}
	function recurse(obj: any, current: string = '') {
		for (const key in obj) {
			const value: any = obj[key]
			if (value != undefined) {
				const newKey: any = current ? current + '.' + key : key
				if (value && typeof value === 'object') {
					recurse(value, newKey)
				} else {
					res[newKey] = value
				}
			}
		}
	}
	recurse(obj)
	return res
}
